import MemberBanner from "./Member-Banner/MemberBanner";
import MemberSlide from "./Member-Slide/MemberSlide";
import Contact from "../Contact/Contact";
import BehindSuccess from "./Behind-The-Success/BehindSuccess";
import Towards from "./Towards/Towards";
export default function MemberTeam() {
  return (
    <div className="w-full ">
      <MemberBanner />
      <BehindSuccess />
      <MemberSlide />
      <Towards />
      <Contact />
    </div>
  );
}
